import { useQuery } from "@tanstack/react-query";

import { useSelectedWorkspaceContext } from "common/context/SelectedWorkspaceContext";
import getQueryKeys from "common/datahooks/getQueryKeys";
import { get } from "common/helpers/HTTP";

export type AccountPreferences = { autoaccept: boolean };

async function getAccountPreferences(
  workspaceId: string,
  accountId: string,
): Promise<AccountPreferences> {
  const { preferences } = await get(
    `workspaces/${workspaceId}/accounts/${accountId}/preferences`,
  );
  return preferences;
}

export default function useAccountPreferences(accountId: string) {
  const { id: workspaceId } = useSelectedWorkspaceContext();

  const { data: preferences, isLoading: isLoadingPreferences } = useQuery({
    queryKey: getQueryKeys(workspaceId).accountsKeys.preferences(accountId),
    queryFn: () => getAccountPreferences(workspaceId, accountId),
  });

  return {
    preferences,
    isLoadingPreferences,
  };
}
